import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Spinner, Center } from '@chakra-ui/react';

type ProtectedRouteProps = {
  children: React.ReactElement;
};

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // 認証状態の初期化中はローディング表示
  if (isLoading) {
    return (
      <Center flex={1}>
        <Spinner size="xl" color="teal.500" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    // ログインしていない場合はトップ画面へリダイレクト
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};
